var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-view" }, [
    _vm.whiteLabelCeline
      ? _c("div", { staticClass: "header" }, [
          _c("h4", { staticClass: "title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.i18nFieldValue(_vm.maintag, "name")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm.collectionNames[0]
            ? _c("h5", { staticClass: "title" }, [
                _vm._v("\n      " + _vm._s(_vm.collectionNames[0]) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("pre", { staticClass: "description header__description" }, [
            _vm._v(_vm._s(_vm.i18nFieldValue(_vm.maintag, "description"))),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _vm.whiteLabelCeline
            ? _c("img", {
                staticClass: "main-photo",
                attrs: { src: _vm.maintag.images[0] },
                on: {
                  contextmenu: function ($event) {
                    $event.preventDefault()
                    return _vm.rightClickBlock.apply(null, arguments)
                  },
                  click: function ($event) {
                    return _vm.$emit("preview", 0)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.whiteLabelCeline
            ? _c("h4", { staticClass: "title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.i18nFieldValue(_vm.maintag, "name")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.collectionNames[0]
            ? _c("h5", { staticClass: "title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.collectionNames[0]) + "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("i-tag-list", {
            staticClass: "marker-info-category",
            attrs: {
              tags:
                _vm.maintag.categoryMulti[_vm.$i18n.locale] ||
                _vm.maintag.category,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-action" },
            [
              _vm.collectionNames[0]
                ? [
                    _c("span", { staticClass: "overflow-ellipsis" }, [
                      _vm._v(_vm._s(_vm.findWholesalePrice(_vm.maintag))),
                    ]),
                  ]
                : [
                    !_vm.isJoorActionTag(_vm.maintag)
                      ? [
                          _c("span", { staticClass: "overflow-ellipsis" }, [
                            _vm._v(
                              _vm._s(_vm.i18nFieldValue(_vm.maintag, "price"))
                            ),
                          ]),
                        ]
                      : _vm._e(),
                  ],
              _vm._v(" "),
              (_vm.isJoorActionTag(_vm.maintag) && _vm.isInJoorPlatform) ||
              !_vm.isJoorActionTag(_vm.maintag)
                ? [
                    _vm.maintag.action
                      ? _c(
                          "a",
                          {
                            staticClass: "cta-btn overflow-ellipsis",
                            on: {
                              click: function ($event) {
                                return _vm.handleActionClick(_vm.maintag, 0)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getActionMutate(_vm.maintag)) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          !_vm.whiteLabelCeline
            ? [
                _c("div", { staticClass: "main-photo-wrapper" }, [
                  _vm.isMainTagArViewButtonVisible
                    ? _c(
                        "button",
                        {
                          ref: "maintagTooltipButton",
                          staticClass: "arview-button",
                          on: {
                            mouseenter: _vm.showMainTagViewIn3DTooltip,
                            mouseleave: _vm.hideMainTagViewIn3DTooltip,
                            click: function ($event) {
                              return _vm.showArView(_vm.maintag)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/armaker/arview-cube.png"),
                            },
                          }),
                          _vm._v(" "),
                          _vm.isMainTagViewIn3DTooltipVisible
                            ? _c("div", { staticClass: "tooltip" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("viewIn3D")) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "main-photo",
                    attrs: { src: _vm.maintag.images[0] },
                    on: {
                      contextmenu: function ($event) {
                        $event.preventDefault()
                        return _vm.rightClickBlock.apply(null, arguments)
                      },
                      click: function ($event) {
                        return _vm.$emit("preview", 0)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("pre", { staticClass: "description" }, [
                  _vm._v(
                    _vm._s(_vm.i18nFieldValue(_vm.maintag, "description"))
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "div",
          { staticClass: "gallery hide-scroll" },
          _vm._l(_vm.subtags, function (subtag, i) {
            return _c(
              "div",
              { key: subtag.objectId, staticClass: "gallery__item" },
              [
                _c("div", { staticClass: "sub-photo-wrapper" }, [
                  _vm.isArViewButtonVisible(subtag)
                    ? _c(
                        "button",
                        {
                          staticClass: "arview-button",
                          on: {
                            click: function ($event) {
                              return _vm.showArView(subtag)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/armaker/arview-cube.png"),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  subtag.photo
                    ? _c("img", {
                        staticClass: "gallery__photo",
                        attrs: { src: subtag.images[0] },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("preview", i + 1)
                          },
                          contextmenu: function ($event) {
                            $event.preventDefault()
                            return _vm.rightClickBlock.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gallery__info hide-scroll" },
                  [
                    _c("h5", { staticClass: "title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.i18nFieldValue(subtag, "name")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.collectionNames[i + 1]
                      ? _c("h5", { staticClass: "title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.collectionNames[i + 1]) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i-tag-list", {
                      staticClass: "marker-info-category",
                      attrs: {
                        tags:
                          subtag.categoryMulti[_vm.$i18n.locale] ||
                          subtag.category,
                      },
                    }),
                    _vm._v(" "),
                    _c("pre", { staticClass: "description" }, [
                      _vm._v(_vm._s(_vm.i18nFieldValue(subtag, "description"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                subtag.action
                  ? _c(
                      "div",
                      { staticClass: "gallery__action" },
                      [
                        (_vm.isJoorActionTag(subtag) && _vm.isInJoorPlatform) ||
                        !_vm.isJoorActionTag(subtag)
                          ? [
                              _c("a", {
                                staticClass: "cta-btn overflow-ellipsis",
                                attrs: { title: _vm.getActionMutate(subtag) },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getActionMutate(subtag)
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleActionClick(subtag, i + 1)
                                  },
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.collectionNames[i + 1]
                          ? [
                              _c("span", { staticClass: "overflow-ellipsis" }, [
                                _vm._v(_vm._s(_vm.findWholesalePrice(subtag))),
                              ]),
                            ]
                          : [
                              !_vm.isJoorActionTag(subtag)
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "overflow-ellipsis",
                                        attrs: {
                                          title: _vm.i18nFieldValue(
                                            subtag,
                                            "price"
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.i18nFieldValue(subtag, "price")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }